import { call, put, takeLatest } from 'redux-saga/effects';
import { ClearingsActionType, ClearingsActions } from './actions';
import {
  getDailyClearings,
  createClearingsReport,
  clearingsManualUpload,
  getMonthlyClearings,
  GetMonthlyClearingsResponse
} from '@card/commonlib';
import { ClearingSummary } from '@card/types';

function* fetchDaily(action: ReturnType<typeof ClearingsActions.fetchDailyStarted>) {
  try {
    const dailyClearings: ClearingSummary = yield call(getDailyClearings, action.payload);
    yield put(ClearingsActions.fetchDailySuccess(dailyClearings));
  } catch (error) {
    yield put(ClearingsActions.fetchDailyError(error));
  }
}

function* fetchMonthly(action: ReturnType<typeof ClearingsActions.fetchMonthlyStarted>) {
  try {
    const data: GetMonthlyClearingsResponse = yield call(getMonthlyClearings, action.payload);
    yield put(ClearingsActions.fetchMonthlySuccess(data));
  } catch (error) {
    yield put(ClearingsActions.fetchMonthlyError(error));
  }
}

function* createReport(action: ReturnType<typeof ClearingsActions.createReportStarted>) {
  try {
    yield call(createClearingsReport, action.payload);
  } catch (error) {
    yield put(ClearingsActions.createReportError(error));
  }
}

function* manualUpload(action: ReturnType<typeof ClearingsActions.manualUploadStarted>) {
  try {
    yield call(clearingsManualUpload, action.payload);
    yield put(ClearingsActions.manualUploadSuccess());
  } catch (error) {
    yield put(ClearingsActions.manualUploadError(error));
  }
}

export function* clearingsSagas() {
  yield takeLatest(ClearingsActionType.FetchDailyStarted, fetchDaily);
  yield takeLatest(ClearingsActionType.FetchMonthlyStarted, fetchMonthly);
  yield takeLatest(ClearingsActionType.CreateReportStarted, createReport);
  yield takeLatest(ClearingsActionType.ManualUploadStarted, manualUpload);
}
